// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/assets/images/main-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @import "./components/reboot";
@import "./components/grid";
@import "./components/type";
@import "./components/buttons";
@import "./components/forms";
@import "./components/input-group";
@import "./components/text";
@import "./components/custom-forms"; */
html {
  font-size: 14px;
}

body {
  margin: 0;
  padding: 0;
  font-family: "Open Sans", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

a {
  color: #00c179;
}
a:hover {
  text-decoration: none;
}

.list-unstyled {
  list-style: none;
}

.badge {
  display: inline-block;
  width: 1.2em;
  height: 1.2em;
  line-height: 1.2em;
  color: #fff;
  font-size: 12px;
  background: #666;
  text-align: center;
  border-radius: 50%;
}

.text-theme {
  color: #00c179;
}

.clearfix:before, .clearfix:after {
  display: table;
  content: " ";
  clear: both;
}

.pull-left {
  float: left;
}

.pull-right {
  float: right;
}

.text-normal {
  font-size: 12px;
}

.v-hidden {
  visibility: hidden;
}

.form-check-label label,
.form-check-label {
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  margin: 0;
}

.checkbox {
  -webkit-user-select: none;
  user-select: none;
  margin: 0;
}
.checkbox input {
  display: none;
}
.form-check-inline .checkbox input + span {
  margin-right: 5px;
}
.checkbox input + span {
  vertical-align: middle;
  font-size: 14px;
  display: inline-block;
}
.checkbox input + span .on-active {
  display: none;
}
.checkbox input:checked + span .on-active {
  display: inline-block;
}
.checkbox input:checked + span .on-inactive {
  display: none;
}

.has-menu {
  position: relative;
}
.has-menu .has-menu > a:after {
  content: "keyboard_arrow_right";
  display: block;
  position: absolute;
  right: 0;
  top: 0;
  font-family: "Material Icons";
  font-size: 20px;
}

.sub-menu {
  position: absolute;
  top: 100%;
  background: #fff;
  border-top: 3px solid rgb(0%, 55.6862745098%, 34.9121202885%);
  margin: 0;
  margin-top: -3px;
  padding: 0;
  list-style: none;
  min-width: 180px;
  left: 0;
  display: none;
  text-align: left;
  line-height: 1.4;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
}
.sub-menu a {
  font-size: 12px;
  color: #333;
  text-decoration: none;
  display: block;
}
.sub-menu a:hover .rel-icons {
  color: inherit;
}
.sub-menu label span,
.sub-menu a span {
  vertical-align: middle;
  display: inline-block;
}
.sub-menu .unit-name {
  min-width: inherit;
  line-height: inherit;
  margin-left: 0;
}
.sub-menu.right-menu {
  left: auto;
  right: 0;
}
.sub-menu.level-right {
  top: 0;
  left: 100%;
}
.sub-menu.level-left {
  top: 0;
  right: 100%;
  left: auto;
}
.sub-menu.left-top {
  bottom: 100%;
  top: auto;
}
.sub-menu.right-top {
  bottom: 100%;
  top: auto;
  right: 0;
  left: auto;
}
.sub-menu a,
.sub-menu label {
  padding: 6px 9px;
}
.sub-menu label {
  display: block;
  margin: 0;
}
.sub-menu label input {
  vertical-align: middle;
  margin-right: 5px;
}
.sub-menu .rel-icons {
  margin-right: 5px;
  color: #aaa;
}

:hover > .sub-menu {
  display: block;
}

.divider {
  border-top: 1px solid rgb(70%, 70%, 70%);
}

.sub-menu label:hover,
.sub-menu a:hover {
  background: rgb(0%, 69.6862745098%, 43.6893223611%);
  color: #fff;
}

.center-menu {
  left: 50%;
  width: 340px;
  margin-left: -170px;
}

.marker {
  transition: all 0.5s ease-in-out;
}

.pos-name {
  font-weight: bold;
  text-align: center;
  position: absolute;
  width: 200px;
  left: 50%;
  margin-left: -100px;
  margin-top: -20px;
  letter-spacing: 1px;
}

.form-group {
  margin-bottom: 15px;
}

.hilight {
  border: 1px solid rgb(90%, 90%, 90%);
  color: #00c179;
  background: #fff;
  padding: 6px;
  display: inline-block;
  border-radius: 4px;
  margin: 6px 0;
}

.material-icons {
  font-family: "Material Icons";
}

.pointer {
  cursor: pointer;
}

.avatar-O {
  background: #2a3a2d !important;
}

.avatar-D {
  background: #f34225 !important;
}

.avatar-R {
  background: rgba(71, 17, 38, 0.9921568627) !important;
}

.avatar-SP {
  background: #357dff !important;
}

.avatar-A {
  background: #59c785 !important;
}

.avatar-U {
  background: #d3c3c3 !important;
}

.avatar-AA {
  background: rgb(238, 138, 50) !important;
}

.clearAllNotifcations {
  position: absolute;
  z-index: 999;
  background: #f7f7f7;
  border: 0;
  width: 100%;
  padding: 10px 30px;
  font-size: 16px;
  right: 10px;
  max-width: 300px;
  top: 10px;
  cursor: pointer;
  box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.2);
}

.notifications-tr {
  margin-top: 73px;
}

.shown-clearall-btn .notifications-tr {
  margin-top: 115px;
}

.notification-visible {
  height: auto !important;
}

.notification-dismiss {
  font-size: 22px !important;
  line-height: 22px !important;
  width: 22px !important;
  height: 22px !important;
  background: none !important;
  top: 6.5px !important;
  right: 7px !important;
}

.notification-success {
  background: #43a047 !important;
  border-color: #43a047 !important;
  color: #fff !important;
}

.notification-warning {
  background: #ffa000 !important;
  border-color: #ffa000 !important;
  color: #fff !important;
}

.notification-error {
  background: #d32f2f !important;
  border-color: #d32f2f !important;
  color: #fff !important;
}

.notification-info {
  background: #1976d2 !important;
  border-color: #1976d2 !important;
  color: #fff !important;
}

.notification-title {
  color: #fff !important;
}

.notification-visible {
  color: #fff !important;
  padding: 8px 16px !important;
  font-size: 14px !important;
  letter-spacing: 0.01071em;
  line-height: 1.43;
  border-radius: 4px !important;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12) !important;
}
.notification-visible:hover .notification-dismiss {
  display: block;
}

.v-tabs .tab-vertial-wrapper {
  display: flex;
  flex-direction: row;
}
.v-tabs .tab-vertial-wrapper > .custom-tabs {
  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  width: 250px;
  margin: 0 24px 0 0;
}

.breadcurmb-row .MuiBreadcrumbs-li:first-child:before {
  content: "";
  display: inline-block;
  width: 0;
  height: 0;
  border-style: solid;
  border-color: transparent transparent transparent #00c179;
  border-width: 5px 10px;
}
.breadcurmb-row .MuiBreadcrumbs-separator {
  color: #00c179;
}

.v-filter-field {
  color: #999;
  border: 1px solid;
  display: block;
  width: 100%;
  padding: 5px 14px;
  font-size: 12px;
  border-radius: 4px;
  box-sizing: border-box;
  margin-top: 7px;
  margin-bottom: 4px;
}

#multi-select-menu .MuiFormControlLabel-root {
  margin-right: 0;
}

.StatBox {
  padding: 22px 0px;
}
.StatBox span {
  vertical-align: "middle";
  border-radius: 3px;
  background: #227fbb;
  padding: 2px 5px;
  margin-left: 5px;
  color: white;
}
.StatBox i {
  font-size: 12px;
}
.StatBox b {
  margin-left: 4px;
}

.StatBox2 {
  padding: 0px;
}
.StatBox2 span {
  vertical-align: "middle";
  border-radius: 3px;
  background: #227fbb;
  padding: 2px 5px;
  margin-left: 5px;
  color: white;
}
.StatBox2 i {
  font-size: 12px;
}
.StatBox2 b {
  margin-left: 4px;
}`, "",{"version":3,"sources":["webpack://./src/assets/main.scss","webpack://./src/assets/variables.scss"],"names":[],"mappings":"AAQA;;;;;;;sCAAA;AAQA;EACE,eAAA;AAPF;;AAUA;EACE,SAAA;EACA,UAAA;EACA,oCCmDe;EDlDf,mCAAA;EACA,kCAAA;EAEA,mDAAA;AARF;;AAYA;EACE,+EAAA;AATF;;AAaA;EACE,cCnCW;ADyBb;AAWE;EACE,qBAAA;AATJ;;AAYA;EACE,gBAAA;AATF;;AAWA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,WCRW;EDSX,eCoBa;EDnBb,gBCXS;EDYT,kBAAA;EACA,kBAAA;AARF;;AAWA;EACE,cCxDW;ADgDb;;AAYE;EAEE,cAAA;EACA,YAAA;EACA,WAAA;AAVJ;;AAcA;EACE,WAAA;AAXF;;AAaA;EACE,YAAA;AAVF;;AAYA;EACE,eCNa;ADHf;;AAWA;EACE,kBAAA;AARF;;AAUA;;EAEE,eAAA;EACA,yBAAA;EAGA,iBAAA;EACA,SAAA;AAPF;;AASA;EACE,yBAAA;EAGA,iBAAA;EACA,SAAA;AANF;AASE;EACE,aAAA;AAPJ;AASE;EACE,iBAAA;AAPJ;AASE;EACE,sBAAA;EACA,eAAA;EACA,qBAAA;AAPJ;AAQI;EACE,aAAA;AANN;AAUI;EACE,qBAAA;AARN;AAUI;EACE,aAAA;AARN;;AAcA;EACE,kBAAA;AAXF;AAYE;EACE,+BAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,6BAAA;EACA,eAAA;AAVJ;;AAaA;EACE,kBAAA;EACA,SAAA;EACA,gBCxFY;EDyFZ,6DAAA;EACA,SAAA;EACA,gBAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,OAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,wCAAA;AAVF;AAWE;EACE,eAAA;EACA,WCjIQ;EDkIR,qBAAA;EACA,cAAA;AATJ;AAWM;EACE,cAAA;AATR;AAaE;;EAEE,sBAAA;EACA,qBAAA;AAXJ;AAaE;EACE,kBAAA;EACA,oBAAA;EACA,cAAA;AAXJ;AAaE;EACE,UAAA;EACA,QAAA;AAXJ;AAaE;EACE,MAAA;EACA,UAAA;AAXJ;AAaE;EACE,MAAA;EACA,WAAA;EACA,UAAA;AAXJ;AAaE;EACE,YAAA;EACA,SAAA;AAXJ;AAaE;EACE,YAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;AAXJ;AAcE;;EAEE,gBAAA;AAZJ;AAcE;EACE,cAAA;EACA,SAAA;AAZJ;AAaI;EACE,sBAAA;EACA,iBAAA;AAXN;AAcE;EACE,iBAAA;EACA,WAAA;AAZJ;;AAeA;EACE,cAAA;AAZF;;AAcA;EACE,wCAAA;AAXF;;AAaA;;EAEE,mDC7LQ;ED8LR,WC7LW;ADmLb;;AAYA;EACE,SAAA;EACA,YAAA;EACA,mBAAA;AATF;;AAYA;EACE,gCAAA;AATF;;AAWA;EACE,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;AARF;;AAWA;EACE,mBAAA;AARF;;AAWA;EACE,oCAAA;EACA,cCxPW;EDyPX,gBAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,aAAA;AARF;;AAUA;EACE,6BAAA;AAPF;;AASA;EACE,eAAA;AANF;;AAQA;EACE,8BAAA;AALF;;AAOA;EACE,8BAAA;AAJF;;AAMA;EACE,qDAAA;AAHF;;AAKA;EACE,8BAAA;AAFF;;AAIA;EACE,8BAAA;AADF;;AAGA;EACE,8BAAA;AAAF;;AAEA;EACE,wCAAA;AACF;;AACA;EACE,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,SAAA;EACA,eAAA;EACA,0CAAA;AAEF;;AAAA;EACE,gBAAA;AAGF;;AAAA;EACE,iBAAA;AAGF;;AAAA;EACE,uBAAA;AAGF;;AADA;EACE,0BAAA;EACA,4BAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;EACA,qBAAA;EACA,qBAAA;AAIF;;AAFA;EACE,8BAAA;EACA,gCAAA;EACA,sBAAA;AAKF;;AAHA;EACE,8BAAA;EACA,gCAAA;EACA,sBAAA;AAMF;;AAJA;EACE,8BAAA;EACA,gCAAA;EACA,sBAAA;AAOF;;AALA;EACE,8BAAA;EACA,gCAAA;EACA,sBAAA;AAQF;;AANA;EACE,sBAAA;AASF;;AAPA;EACE,sBAAA;EACA,4BAAA;EACA,0BAAA;EACA,yBAAA;EACA,iBAAA;EACA,6BAAA;EACA,uDAAA;EACA,sIAAA;AAUF;AAPI;EACE,cAAA;AASN;;AALA;EAEE,aAAA;EACA,mBAAA;AAOF;AANE;EACE,yHAAA;EACA,YAAA;EACA,kBAAA;AAQJ;;AAFI;EACE,WAAA;EACA,qBAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,yDAAA;EACA,sBAAA;AAKN;AAFE;EACE,cC3XS;AD+Xb;;AACA;EACE,WAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;AAEF;;AAAA;EAEE,eAAA;AAEF;;AACA;EACE,iBAAA;AAEF;AADE;EACE,wBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;AAGJ;AADE;EACE,eAAA;AAGJ;AADE;EACE,gBAAA;AAGJ;;AACA;EACE,YAAA;AAEF;AADE;EACE,wBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;AAGJ;AADE;EACE,eAAA;AAGJ;AADE;EACE,gBAAA;AAGJ","sourcesContent":["// =====================================================\n// =====================================================\n// =====================================================\n//                      BASE\n// =====================================================\n// =====================================================\n// =====================================================\n@import './variables';\n/* @import \"./components/reboot\";\n@import \"./components/grid\";\n@import \"./components/type\";\n@import \"./components/buttons\";\n@import \"./components/forms\";\n@import \"./components/input-group\";\n@import \"./components/text\";\n@import \"./components/custom-forms\"; */\nhtml {\n  font-size: 14px;\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n  font-family: $baseFontFamily;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  // background: url('/assets/images/main-bg.png');\n  background: url('../../public/assets/images/main-bg.png');\n\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\na {\n  color: $themeColor;\n  &:hover {\n    text-decoration: none;\n  }\n}\n.list-unstyled {\n  list-style: none;\n}\n.badge {\n  display: inline-block;\n  width: 1.2em;\n  height: 1.2em;\n  line-height: 1.2em;\n  color: $badgeColor;\n  font-size: $baseFontSize;\n  background: $badgeBgColor;\n  text-align: center;\n  border-radius: 50%;\n}\n\n.text-theme {\n  color: $themeColor;\n}\n\n.clearfix {\n  &:before,\n  &:after {\n    display: table;\n    content: ' ';\n    clear: both;\n  }\n}\n\n.pull-left {\n  float: left;\n}\n.pull-right {\n  float: right;\n}\n.text-normal {\n  font-size: $baseFontSize;\n}\n.v-hidden {\n  visibility: hidden;\n}\n.form-check-label label,\n.form-check-label {\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  margin: 0;\n}\n.checkbox {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  margin: 0;\n  //color: #999;\n\n  input {\n    display: none;\n  }\n  .form-check-inline & input + span {\n    margin-right: 5px;\n  }\n  input + span {\n    vertical-align: middle;\n    font-size: 14px;\n    display: inline-block;\n    .on-active {\n      display: none;\n    }\n  }\n  input:checked {\n    + span .on-active {\n      display: inline-block;\n    }\n    + span .on-inactive {\n      display: none;\n    }\n  }\n}\n\n// sub menu\n.has-menu {\n  position: relative;\n  .has-menu > a:after {\n    content: 'keyboard_arrow_right';\n    display: block;\n    position: absolute;\n    right: 0;\n    top: 0;\n    font-family: 'Material Icons';\n    font-size: 20px;\n  }\n}\n.sub-menu {\n  position: absolute;\n  top: 100%;\n  background: $dropdown-bg;\n  border-top: 3px solid $hoverBorderColor;\n  margin: 0;\n  margin-top: -3px;\n  padding: 0;\n  list-style: none;\n  min-width: 180px;\n  left: 0;\n  display: none;\n  text-align: left;\n  line-height: 1.4;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);\n  a {\n    font-size: 12px;\n    color: $textColor;\n    text-decoration: none;\n    display: block;\n    &:hover {\n      .rel-icons {\n        color: inherit;\n      }\n    }\n  }\n  label span,\n  a span {\n    vertical-align: middle;\n    display: inline-block;\n  }\n  .unit-name {\n    min-width: inherit;\n    line-height: inherit;\n    margin-left: 0;\n  }\n  &.right-menu {\n    left: auto;\n    right: 0;\n  }\n  &.level-right {\n    top: 0;\n    left: 100%;\n  }\n  &.level-left {\n    top: 0;\n    right: 100%;\n    left: auto;\n  }\n  &.left-top {\n    bottom: 100%;\n    top: auto;\n  }\n  &.right-top {\n    bottom: 100%;\n    top: auto;\n    right: 0;\n    left: auto;\n  }\n\n  a,\n  label {\n    padding: 6px 9px;\n  }\n  label {\n    display: block;\n    margin: 0;\n    input {\n      vertical-align: middle;\n      margin-right: 5px;\n    }\n  }\n  .rel-icons {\n    margin-right: 5px;\n    color: #aaa;\n  }\n}\n:hover > .sub-menu {\n  display: block;\n}\n.divider {\n  border-top: 1px solid $dropdown-border;\n}\n.sub-menu label:hover,\n.sub-menu a:hover {\n  background: $subMenuHoverBg;\n  color: $subMenuHoverColor;\n}\n.center-menu {\n  left: 50%;\n  width: 340px;\n  margin-left: -340 / 2 * 1px;\n}\n\n.marker {\n  transition: all 0.5s ease-in-out;\n}\n.pos-name {\n  font-weight: bold;\n  text-align: center;\n  position: absolute;\n  width: 200px;\n  left: 50%;\n  margin-left: -100px;\n  margin-top: -20px;\n  letter-spacing: 1px;\n}\n\n.form-group {\n  margin-bottom: 15px;\n}\n\n.hilight {\n  border: 1px solid $borderColor;\n  color: $themeColor;\n  background: #fff;\n  padding: 6px;\n  display: inline-block;\n  border-radius: 4px;\n  margin: 6px 0;\n}\n.material-icons {\n  font-family: 'Material Icons';\n}\n.pointer {\n  cursor: pointer;\n}\n.avatar-O {\n  background: #2a3a2d !important;\n}\n.avatar-D {\n  background: #f34225 !important;\n}\n.avatar-R {\n  background: #471126fd !important;\n}\n.avatar-SP {\n  background: #357dff !important;\n}\n.avatar-A {\n  background: #59c785 !important;\n}\n.avatar-U {\n  background: #d3c3c3 !important;\n}\n.avatar-AA {\n  background: rgb(238, 138, 50) !important;\n}\n.clearAllNotifcations {\n  position: absolute;\n  z-index: 999;\n  background: #f7f7f7;\n  border: 0;\n  width: 100%;\n  padding: 10px 30px;\n  font-size: 16px;\n  right: 10px;\n  max-width: 300px;\n  top: 10px;\n  cursor: pointer;\n  box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.2);\n}\n.notifications-tr {\n  margin-top: 73px;\n}\n\n.shown-clearall-btn .notifications-tr {\n  margin-top: 115px;\n}\n\n.notification-visible {\n  height: auto !important;\n}\n.notification-dismiss {\n  font-size: 22px !important;\n  line-height: 22px !important;\n  width: 22px !important;\n  height: 22px !important;\n  background: none !important;\n  top: 6.5px !important;\n  right: 7px !important;\n}\n.notification-success {\n  background: #43a047 !important;\n  border-color: #43a047 !important;\n  color: #fff !important;\n}\n.notification-warning {\n  background: #ffa000 !important;\n  border-color: #ffa000 !important;\n  color: #fff !important;\n}\n.notification-error {\n  background: #d32f2f !important;\n  border-color: #d32f2f !important;\n  color: #fff !important;\n}\n.notification-info {\n  background: #1976d2 !important;\n  border-color: #1976d2 !important;\n  color: #fff !important;\n}\n.notification-title {\n  color: #fff !important;\n}\n.notification-visible {\n  color: #fff !important;\n  padding: 8px 16px !important;\n  font-size: 14px !important;\n  letter-spacing: 0.01071em;\n  line-height: 1.43;\n  border-radius: 4px !important;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2),\n    0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12) !important;\n  &:hover {\n    .notification-dismiss {\n      display: block;\n    }\n  }\n}\n.v-tabs \n.tab-vertial-wrapper {\n  display: flex;\n  flex-direction: row;\n  > .custom-tabs {\n    box-shadow: 0px 2px 1px -1px rgba(black, 0.2), 0px 1px 1px 0px rgba(black, 0.14), 0px 1px 3px 0px rgba(black, 0.12);\n    width: 250px;\n    margin: 0 24px 0 0;\n  }\n}\n\n.breadcurmb-row {\n  .MuiBreadcrumbs-li:first-child {\n    &:before {\n      content: \"\";\n      display: inline-block;\n      width: 0;\n      height: 0;\n      border-style: solid;\n      border-color:  transparent transparent transparent $themeColor;\n      border-width: 5px 10px;\n    }\n  }\n  .MuiBreadcrumbs-separator {\n    color: $themeColor;\n  }\n}\n\n\n.v-filter-field {\n  color: #999;\n  border: 1px solid;\n  display: block;\n  width: 100%;\n  padding: 5px 14px;\n  font-size: 12px;\n  border-radius: 4px;\n  box-sizing: border-box;\n  margin-top: 7px;\n  margin-bottom: 4px;\n}\n#multi-select-menu\n.MuiFormControlLabel-root {\n  margin-right: 0;\n} \n\n.StatBox {\n  padding:22px 0px;\n  span {\n    vertical-align: 'middle';\n    border-radius: 3px;\n    background: #227fbb; \n    padding:2px 5px ;\n    margin-left:5px;\n    color: white\n  }\n  i {\n    font-size: 12px;\n  }\n  b {\n    margin-left: 4px;\n  }\n  \n}\n.StatBox2 {\n  padding:0px;\n  span {\n    vertical-align: 'middle';\n    border-radius: 3px;\n    background: #227fbb; \n    padding:2px 5px ;\n    margin-left:5px;\n    color: white\n  }\n  i {\n    font-size: 12px;\n  }\n  b {\n    margin-left: 4px;\n  }\n  \n}","@import 'functions';\n@import 'mixins';\n$themeColor: #00c179;\n$input-focus-box-shadow: none;\n$input-btn-focus-box-shadow: none;\n$btn-active-box-shadow: none;\n$input-focus-border-color: inherit;\n$btn-active-box-shadow: none;\n$input-bg: #fbfeff;\n$input-border-radius: 100px;\n$input-border-radius-sm: 100px;\n$input-border-radius-lg: 100px;\n$input-border-color: #e2e9ef;\n//$input-padding-x-sm: 10px;\n@import 'bs_variables';\n\n// Layouts\n$sidebarWidth: 285px;\n$headerHeight: 46px;\n$footerHeight: 27px;\n$mapFiltersHeight: 36px;\n$mapWidgetsHeight: 150px;\n\n$themeColorInverse: #fff;\n$textColor: #333;\n$body-color: #333;\n$logoColor: $themeColor; //#012D55;\n\n// Header\n\n$borderColor: darken(white, 10%);\n$linkColor: #666;\n$hoverBg: darken($themeColor, 3%);\n$hoverColor: #fff;\n$hoverBorderColor: darken($themeColor, 10%);\n$subMenuHoverBg: $hoverBg;\n$subMenuHoverColor: $hoverColor;\n$menuBg: #fff;\n$blue: #012d55;\n\n// general\n$darkGrey: #666;\n$badgeColor: #fff;\n$badgeBgColor: $darkGrey;\n$greenColor: #28a745;\n$redColor: #dc3545;\n$skyColor: $themeColor;\n$yellowColor: #ffc107;\n$bodyBg: #f3f3f3;\n$lightGrey: #999;\n\n$dropdown-bg: #fff;\n$dropdown-border: darken($dropdown-bg, 30%);\n\n$danger: $redColor;\n$warning: $yellowColor;\n$success: $greenColor;\n\n// Sidebar\n$sidebarBackground: #fff;\n$sidebarzIndex: 8;\n$sidebarHeadBg: #f9f9f9;\n$sidebarRowBg: #fff;\n$sidebarRowHoverBg: #eee;\n$sidebarRowColor: $darkGrey;\n\n// Footer\n\n$footerBackground: $themeColor;\n\n// typography\n$baseFontSize: 12px;\n$baseIconFontSize: 17px;\n\n$baseFontFamily: 'Open Sans', sans-serif;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
